import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { BundleService } from "src/app/Services/bundleservice.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { ViewReportedFlowComponent } from "../view-reported-flow/view-reported-flow.component";
import { SupportDocumentComponent } from "../support-document/support-document.component";
import { SupportFaqComponent } from "../support-faqs/support-faqs.component";
import { ShowFlowImageDialogComponent } from "../show-flow-image-dialog/show-flow-image-dialog.component";
import { DataService } from "src/app/Services/dataservice.service";

@Component({
  selector: "app-view-reported-bundle",
  templateUrl: "./view-reported-bundle.component.html",
  styleUrls: ["./view-reported-bundle.component.scss"],
})
export class ViewReportedBundleComponent implements OnInit {
  userData: any;
  contentRowKey: any;
  noResultReturned: boolean;
  bundleData: any;
  titleandmetaserviceService: any;
  isPurchaseRequired: boolean;
  showMenu: boolean;
  likecolor: boolean;
  bookmarkcolor: string;
  saveCount: any;
  viewsCount: any;
  showImage: boolean;
  videoPlayCounter: any = [];
  viewUnloaded: any;
  showVideo: boolean;
  imageSource: string;
  contentType: string = "";
  reportedContent: any = null;

  constructor(
    private dataService: DataService,
    private flowServiceService: FlowServiceService,
    private bundleService: BundleService,
    private toastr: ToastrService,
    public formbuilder: UntypedFormBuilder,
    public router: Router,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ViewReportedFlowComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  async ngOnInit(): Promise<void> {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    if (this.userData != null) {
      this.contentRowKey = this.data.contentId;
      this.contentType = this.data.contentType || "";
      this.reportedContent = this.data.reportedContent || null;
      await this.getBundleDetails(this.contentRowKey);
    } else {
      this.router.navigate(["/"]);
    }
  }

  getBundleDetails(bundleId) {
    //
    this.noResultReturned = true;
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      BundleId: bundleId,
      userEmail: email,
    });

    this.bundleService.getBundleById(flowQueryModel).subscribe({
      next: (data) => {
        this.noResultReturned = false;

        if (data.bundleModel != null) {
          this.bundleData = data.bundleModel;
          console.log(this.bundleData);
          // this.titleandmetaserviceService.setTitle(this.bundleData.title);
          this.showVideoFromFile(this.bundleData.url);
          this.isPurchaseRequired = false;

          if (
            this.userData != null &&
            this.userData.emailAddress != this.bundleData.customerEmail
          ) {
            this.showMenu = true;
            this.isPurchaseRequired =
              !this.bundleData.isFlowPurchased && this.bundleData.isPaid;
          } else if (
            this.userData != null &&
            this.userData.emailAddress == this.bundleData.customerEmail
          ) {
            this.showMenu = false;
          } else {
            this.showMenu = true;
            this.isPurchaseRequired =
              !this.bundleData.isFlowPurchased && this.bundleData.isPaid;
          }

          if (data.bundleModel.isLiked === "liked") {
            this.likecolor = true;
          } else if (data.bundleModel.isLiked === "unliked") {
            this.likecolor = false;
          }

          if (data.bundleModel.isSaved === true) {
            this.bookmarkcolor = "#5ea1d8";
            this.saveCount = data.bundleModel.saveCount;
          } else {
            this.bookmarkcolor = "gray";
            this.saveCount = data.bundleModel.saveCount;
          }
          console.log(this.bundleData);
          this.viewsCount = this.bundleData.viewsCount;

          if (
            this.bundleData.profilePic != undefined &&
            this.bundleData.profilePic != null &&
            this.bundleData.profilePic != ""
          ) {
            this.showImage = true;
          } else {
            this.showImage = false;
          }
          // }
          // this.recordPageView();
        } else {
          this.handleBundleNotFoundError();
        }
      },
      error: (err) => {
        console.error("Bundle fetch error:", err);
        this.handleBundleNotFoundError(err);
      },
    });
  }
  private handleBundleNotFoundError(err?) {
    const errorMessage = err?.status
      ? "The bundle you are trying to open is no longer available."
      : `We’re unable to display the content right now due to: ${
          err?.message || "an unexpected issue"
        }. Please try again later.`;
    this.toastr.success(errorMessage);
    this.router.navigate(["/"]);
  }

  viewUserProfile(selectedFlow) {
    const userFlows = [];
    if (this.userData != null) {
      if (this.userData.emailAddress === selectedFlow.customerEmail) {
        userFlows.push(selectedFlow);
        this.router.navigate(["/user-profile"]);
      } else {
        this.router.navigate(["/view-profile"]);
      }
      this.dataService.flowByCategorieschangeMessage(selectedFlow);
    } else {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
      localStorage.setItem("returnUrl", this.router.url);
      this.router.navigate(["/registration"]);
    }
  }
  ViewSupportingDocuments() {
    if (this.bundleData.isPaid && this.userData == null) {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
      localStorage.setItem("returnUrl", this.router.url);
      this.router.navigate(["/registration"]);
    } else {
      //this.router.navigate(["/in-Appropriate"]);
      localStorage.setItem("flowData", JSON.stringify(this.bundleData));
      const dialogRef = this.dialog.open(SupportDocumentComponent, {
        panelClass: "dialoguebox",
      });
      dialogRef.afterClosed().subscribe((result) => {});
    }
  }

  ViewSupportingFaqs() {
    const faqs = this.supportFaqModels;
    if (!faqs || faqs.length === 0) {
      return;
    }

    localStorage.setItem("flowData", JSON.stringify(this.bundleData));
    localStorage.setItem("supportFaq", JSON.stringify(faqs));
    const dialogRef = this.dialog.open(SupportFaqComponent, {
      panelClass: "dialoguebox",
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  openImage(url) {
    localStorage.setItem("itemsRequiredImageToShow", url);

    this.dialog.open(ShowFlowImageDialogComponent, {
      panelClass: ["media-dialog-pane", "media-dialog"],
      backdropClass: "custom-backdrop",
      maxWidth: "95vw",
      width: "auto",
      maxHeight: "95vh",
      height: "auto",
      autoFocus: false,
      restoreFocus: false,
    });
  }
  flowClicked(flow) {
    localStorage.setItem("notificationflowId", null);
    //localStorage.setItem("flow", JSON.stringify(flow));
    localStorage.removeItem("flow"); //, JSON.stringify(flow));
    localStorage.setItem("navigateTo", "/");
    if (flow.Type == "Bundle") {
      this.router.navigate(["/view-guide-pack/" + flow.rowKey]);
    } else {
      this.router.navigate([
        `/guide/${this.generateUrlSlug(flow.title)}/${flow.rowKey}`,
      ]);
    }
  }
  generateUrlSlug(html) {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents (é → e, ñ → n)
      .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters except spaces and "-"
      .trim() // Trim spaces from start/end
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/-+/g, "-") // Remove duplicate dashes
      .toLowerCase(); // Convert to lowercase
  }
  openLink(url) {
    if (this.isPurchaseRequired) return;
    else {
      if (url.includes("https://")) {
        url = url;
        window.open(url);
        // this.recordLinkClick(url);
      } else {
        url = "https://" + url;
        window.open(url);
        // this.recordLinkClick(url);
      }
    }
  }
  openDocument(documentName) {
    if (this.isPurchaseRequired) return;
    window.open(documentName);
  }

  vidEnded(event) {
    var playcount = 0;
    var video = this.videoPlayCounter.filter(
      (v) => v.currentSrc == event.target.currentSrc
    );
    if (video != null) {
      playcount = video.length;
    }

    if (playcount < 3) {
      this.videoPlayCounter.push({
        eventobj: event,
        currentSrc: event.target.currentSrc,
        playcount: playcount,
      });
      event.target.play();
    }
  }

  vidfocus(event) {}

  vidplay(event) {
    if (!this.viewUnloaded) {
      var videos = this.videoPlayCounter?.filter(
        (v) => v.id == event.target.id
      );

      if (videos.length > 3) {
        videos.forEach((element) => {
          var obj = this.videoPlayCounter.indexOf(element);

          if (obj > -1) {
            this.videoPlayCounter.splice(obj, 1);
          }
        });
      }
      event.target.play();
    }
  }

  showVideoFromFile(filePath: string) {
    if (
      filePath.includes("MP4") ||
      filePath.includes("mp4") ||
      filePath.includes("MOV") ||
      filePath.includes("mov") ||
      filePath.includes("WMV") ||
      filePath.includes("wmv") ||
      filePath.includes("FLV") ||
      filePath.includes("flv") ||
      filePath.includes("AVCHD") ||
      filePath.includes("avchd") ||
      filePath.includes("WEBM") ||
      filePath.includes("webm") ||
      filePath.includes("MKV") ||
      filePath.includes("mkv") ||
      filePath.includes("VOB") ||
      filePath.includes("vob") ||
      filePath.includes("OGV") ||
      filePath.includes("ogv") ||
      filePath.includes("GIFY") ||
      filePath.includes("gifv") ||
      filePath.includes("M4P") ||
      filePath.includes("m4p") ||
      filePath.includes("M4V") ||
      filePath.includes("m4v") ||
      filePath.includes("3GP") ||
      filePath.includes("3gp") ||
      filePath.includes("3G2") ||
      filePath.includes("3g2") ||
      filePath.includes("AMV") ||
      filePath.includes("amv") ||
      filePath.includes("NSV") ||
      filePath.includes("nsv") ||
      filePath.includes("OGG") ||
      filePath.includes("ogg") ||
      filePath.includes("FLV") ||
      filePath.includes("flv") ||
      filePath.includes("F4V") ||
      filePath.includes("f4v") ||
      filePath.includes("F4P") ||
      filePath.includes("f4p") ||
      filePath.includes("F4A") ||
      filePath.includes("f4a") ||
      filePath.includes("F4B") ||
      filePath.includes("f4b")
    ) {
      this.showVideo = true;
      this.imageSource = filePath;
    } else {
      this.showImage = false;
      this.imageSource = filePath;
    }
  }

  takeDown() {
    this.dialogRef.close(true); // user chose "yes"
  }

  markAsFine() {
    this.dialogRef.close(false); // user chose "no"
  }
  close() {
    this.dialogRef.close(); // user chose "no"
  }

  // Helper method to check if URL is a video
  isVideoUrl(url: string): boolean {
    if (!url) {
      return false;
    }
    const extension = this.getExtension(url);
    if (!extension) {
      return false;
    }
    return this.videoFileExtensions.includes(extension.toLowerCase());
  }

  private readonly videoFileExtensions: string[] = [
    "mp4",
    "mov",
    "wmv",
    "flv",
    "avchd",
    "webm",
    "mkv",
    "vob",
    "ogv",
    "gifv",
    "m4p",
    "m4v",
    "3gp",
    "3g2",
    "amv",
    "nsv",
    "ogg",
    "f4v",
    "f4p",
    "f4a",
    "f4b",
  ];

  private getExtension(path: string): string {
    if (!path) {
      return "";
    }
    let sanitizedPath = path.split("?")[0].split("#")[0];
    const lastDot = sanitizedPath.lastIndexOf(".");
    if (lastDot === -1 || lastDot === sanitizedPath.length - 1) {
      return "";
    }
    return sanitizedPath.substring(lastDot + 1);
  }

  // Stub methods for mobile view actions (not needed for reported bundle view but required by template)
  likeFlow() {
    // Not implemented for reported bundle view
  }

  onChatClick() {
    // Not implemented for reported bundle view
  }

  openForECode(bundleData: any) {
    // Not implemented for reported bundle view
  }

  saveFlow() {
    // Not implemented for reported bundle view
  }

  purchaseBundle() {
    // Not implemented for reported bundle view
  }

  followUser() {
    // Not implemented for reported bundle view
  }

  get followButtonText(): string {
    return "Follow"; // Stub
  }

  get showFollow(): boolean {
    return false; // Stub - not needed for reported bundle view
  }

  get hasSupportingDocuments(): boolean {
    const docsCount =
      this.bundleData?.flowSupportingDocumentsDocumentModels?.length || 0;
    const linksCount =
      this.bundleData?.flowSupportingDocumentsHyperLinkModels?.length || 0;
    return docsCount + linksCount > 0;
  }

  get supportFaqModels(): any[] {
    const candidates = [
      this.bundleData?.supportFaqModels,
      this.bundleData?.supportFaqModel,
      this.bundleData?.supportFaqs,
      this.bundleData?.supportFaq,
      this.bundleData?.flowSupportFaqModels,
      this.reportedContent?.supportFaqModels,
      this.reportedContent?.supportFaqModel,
      this.reportedContent?.supportFaqs,
      this.reportedContent?.supportFaq,
      this.reportedContent?.flowSupportFaqModels,
    ];

    const found = candidates.find((value) => Array.isArray(value));
    return Array.isArray(found) ? found : [];
  }

  get hasSupportFaqs(): boolean {
    return this.supportFaqModels.length > 0;
  }
}
